export default () =>
  import(
    /* webpackChunkName: 'coffee/mini/card-coupon/description' */ './Description'
  );
